import { useEffect, useState } from "react";

export default function AppLoader({ show }) {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    if (show) {
      setVisible(true);
    } else {
      // wait for fade-out before unmount
      const timer = setTimeout(() => setVisible(false), 400);
      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!visible) return null;

  return (
    <div className={`app-loader ${show ? "enter" : "exit"}`}>
      <img src="Images/Logo.png" alt="Loading" className="loader-logo" />
    </div>
  );
}